// 主数据-供应链主数据国际化配置
export default {
  supplyChain: {
    label: {
      supplier: '供应链主体供应商',
      customer: '供应链主体客户',
      supplierCode: '供应链主体编码',
      writeSupplierCode: '请输入供应链主体编码',
      supplierName: '供应链主体名称',
      writeSupplierName: '请输入供应链主体名称',
      startTime: '申请日期从',
      endTime: '申请日期到',
      // searchCode: "搜索简码",
      status: '申请单状态',
      fullName: '客户全称',
      supplyName: '供应商名称',
      supplyCode: '供应商编号',
      partnerCode: '客户编码',
      extendDepartment: '申请扩展部门',
      sourceSupplieCode: '原编码',
      targetSupplierCode: '改为',
      searchCode: '简码',
      writeSearchCode: '请输入简码',
    },
    placeholder: {
      input: '请输入',
      select: '请选择',
      supplierName: '请选择供应链主体',
    },
    message: {
      perfectPurchasingData: '请将采购数据填写完整',
      perfectSalesData: '请将销售数据填写完整',
      dataRepeat: '数据已存在',
      pleaseSelectOne: '请选择一条数据操作',
      noData: '暂无数据，请到合作伙伴页面新增',
      isExtend: '数据已存在是否扩展',
      theDepartmentNoData: '该部门不存在此条数据',
      perfectBank: '请将银行表格填写完整',
      perfectPerson: '请将联系人表格填写完整',
    },
    dialog: {
      extend: '扩展申请',
      merge: '合并',
      partnerList: '合作伙伴列表',
    },
    router: {
      add: '新建供应链主数据',
      edit: '修改供应链主数据',
      list: '供应链主数据',
    },
    button: {
      cancel: '取 消',
      sure: '确 定',
    },
  },
};
